module.exports = __webpack_public_path__ + "static/media/upi.327fd08b.png";